import { render } from "./home.vue?vue&type=template&id=2d2d7d88&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=2d2d7d88&lang=scss&scoped=true"

import exportComponent from "E:\\exercise\\skyMap\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2d7d88"]])

export default __exports__